<template>
<div class="date-wrapper">
	<input type="text" class="dateInput" :value="rangeValues[0]" @keyup.enter="updateDateInput($event, 0)" @blur="updateDateInput($event, 0)"/>
	<div id="dateSlider">
		<VueSlider
			:value="rangeValues"
			ref="slider"
			:dotSize="26"
			:height="10"
			:data="dateRangeArray()"
			tooltip="none"
			@drag-start="startSlide"
			@change="changed"
			@drag-end="endSlide"/>
		<!-- <div id="dateJumpWrapper">
			<div id="dateJump" :style="{width: fixedTrackWidth + 'px'}">
				<div class="1year jump" @click="jumpYears(1)" :style="{right: year1Point + 'px'}">1 yr</div>
				<div class="3year jump" @click="jumpYears(3)" :style="{right: year3Point + 'px'}">3 yrs</div>
				<div class="5year jump" @click="jumpYears(5)" :style="{right: year5Point + 'px'}">5 yrs</div>
			</div>
		</div> -->
	</div>
	<input type="text" class="dateInput" :value="rangeValues[1]" @keyup.enter="updateDateInput($event, 1)" @blur="updateDateInput($event, 1)"/>
</div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import vue from 'vue';

export default {
    components: {
        VueSlider,
    },
    props: {
        dateRangeValues: {
            type: Array,
        },
    },
    name: 'dateSlider',
    data () {
        return {
			year5Point: 0,
            daysInView: 0,
            dragging: false,
            firstDate: '',
            fixedTrackWidth: 0,
            lastDate: '',
            rangeValues: [],
            trackWidth: 100,
            year1Point: 0,
            year3Point: 0,
        };
    },
    created () {
        this.rangeValues = [this.dateRangeArray()[0], this.dateRangeArray()[this.dateRangeArray().length - 1]];
        this.daysInView = this.$moment(this.rangeValues[1], 'DD/MM/YYYY').diff(this.$moment(this.rangeValues[0], 'DD/MM/YYYY'), 'days');
    },
    mounted () {
        this.fixedTrackWidth = this.$refs.slider.$el.clientWidth - 26; // 26 px offset for intial padding
        this.year1Point = this.calc1Year();
        this.year3Point = this.calc3Year();
        this.year5Point = this.calc5Year();
    },
    methods: {
        // called when slider has been pressed on
        startSlide (event) {
            this.dragging = true;
        },
        // called when slider has had mouse button depressed
        endSlide (event) {
            this.dragging = false;
            this.changeData(this.currentValue);
        },
        // called when the slider is moving
        changed (val) {
			vue.set(this.rangeValues, 0, val[0]);
			vue.set(this.rangeValues, 1, val[1]);
            this.currentValue = val;
            !this.dragging ? this.changeData(val) : '';
        },
        // Returns the data range array to use in slider
        dateRangeArray () {
			return this.$store.state.ui.sliderDates;
        },
        // converts the date from uk to iso
        isoDate (date) {
            const day = date.slice(0, date.indexOf('/'));
            date = date.slice(date.indexOf('/') + 1, date.length);
            const month = date.slice(0, date.indexOf('/'));
            const year = date.slice(date.indexOf('/') + 1, date.length);
            const isoDate = `${month}-${day}-${year}`;
            return isoDate;
        },
        // runs when date slider values are changed, calls API for new data
        async changeData (val) {
            this.dialog = true;
            const dateArray = val;
            await this.$store.dispatch('loadManagerData', [new Date(this.isoDate(dateArray[0])), new Date(this.isoDate(dateArray[1]))]);
            await this.$store.dispatch('updateDailyData', [new Date(this.isoDate(dateArray[0])), new Date(this.isoDate(dateArray[1]))]);
            await this.$store.commit('resetValueFilter', { root: true });
        },
        jumpYears (years) {
            const startDate = this.$moment(this.rangeValues[1], 'DD/MM/YYYY').subtract(365 * years, 'days').endOf('month').format('DD/MM/YYYY');
            const endDate = this.rangeValues[1];
            this.rangeValues = [startDate, endDate];
            this.changeData(this.rangeValues);
        },
        calc1Year () {
            const percOfTrack = (this.trackWidth / this.daysInView) * 365;
            return (this.fixedTrackWidth / 100) * percOfTrack - 20; // minus 20 is to cover half of inidicator with so the arrow is central
        },
        calc3Year () {
            const percOfTrack = (this.trackWidth / this.daysInView) * 365 * 3;
            return (this.fixedTrackWidth / 100) * percOfTrack - 20;
        },
        calc5Year () {
            const percOfTrack = (this.trackWidth / this.daysInView) * 365 * 5;
            return (this.fixedTrackWidth / 100) * percOfTrack - 20;
		},
		updateDateInput (dateValue, index) {
			if (this.$moment(dateValue.target.value, 'DD/MM/YYYY').isValid()) {
                const rangeIndex = this.dateRangeArray().findIndex((i) => i === dateValue.target.value);
                if (rangeIndex > -1) {
                    vue.set(this.rangeValues, index, dateValue.target.value);
                } else {
					const monthDate = this.$moment(dateValue.target.value, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY');
					const monthIndex = this.dateRangeArray().findIndex((i) => i === monthDate);
					if (monthIndex > -1) {
						vue.set(this.rangeValues, index, this.$moment(dateValue.target.value, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY'));
						this.$notify({
							group: 'note',
							title: 'Date Input Updated',
							text: 'The Date input has been updated to the closest available date.',
							type: 'warn'
						});
					} else {
						vue.set(this.rangeValues, index, this.rangeValues[index]);
						this.$notify({
							group: 'note',
							title: 'Date Input Updated',
							text: 'The Date input has been reverted.',
							type: 'error'
						});
					}
                }
				this.changeData(this.rangeValues);
			}
		}
    }
};
</script>

<style lang="scss">
@import 'src/assets/scss/all.scss';

.date-wrapper {
	display: flex;
	.dateInput {
		padding: 0 5px;
		border: 1px solid #ccc;
		color: #595959;
		height: 30px;
		width: 105px;
		margin: 0 10px;
	}
	.vue-slider-wrap {
		margin-top: 10px;
	}
	.vue-slider-tooltip {
		font-size:12px!important;
		padding: 0px 5px!important;
		background-color: $LCPMarine!important;
		border-color: $LCPMarine!important;
	}
	.vue-slider-tooltip-wrap.vue-slider-tooltip-top {
		left: 50%;
		top: -2px!important;
		transform: translate(-50%,-100%);
	}
	#dateSlider {
		width: 460px;
		padding: 0 10px;
		#dateJumpWrapper {
			margin: 0 13px;
			width: calc(100% - 26px);
			#dateJump {
				height: 25px;
				margin-top: -10px;
				overflow: hidden;
				padding: 0;
				position: relative;
				.jump {
					background: #3498db;
					border-radius: 6px;
					color: #FFFFFF;
					cursor: pointer;
					font-size: 12px;
					height: 20px;
					line-height: 20px;
					position: absolute;
					text-align: center;
					top: 5px;
					width: 40px;
					&:after {
						border-bottom: 6px solid $LCPBlue;
						border-left: 6px solid transparent;
						border-right: 6px solid transparent;
						bottom: 100%;
						content: '';
						left: 50%;
						margin-left: -6px;
						position: absolute;
						width: 0; height: 0;
					}
				}
			}
		}
	}
}
</style>
